var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradeproLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.151,
    height: 23.385,
    viewBox: "0 0 109.151 23.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c51718;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.483 1.088)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.998 8.873)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1260.589,247.815c0,1.617-.718,2.577-2.413,2.577a10.055,10.055,0,0,1-1.949-.209v3.008l-1.826.254v-10.5h1.453l.181.616a3.84,3.84,0,0,1,2.307-.763c1.469,0,2.249.87,2.249,2.532Zm-4.363.825a7.957,7.957,0,0,0,1.617.193c.661,0,.915-.316.915-.973v-2.577c0-.6-.225-.927-.9-.927a2.579,2.579,0,0,0-1.633.661Z",
    transform: "translate(-1254.4 -242.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1452.663,244.379a14.558,14.558,0,0,0-1.933,1.063v4.7H1448.9v-7.293h1.543l.119.809a8.185,8.185,0,0,1,1.917-.96Z",
    transform: "translate(-1440.917 -242.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1565.577,250.3c-2.5,0-3.176-1.379-3.176-2.877v-1.843c0-1.5.673-2.877,3.176-2.877s3.177,1.379,3.177,2.877v1.843C1568.757,248.918,1568.08,250.3,1565.577,250.3Zm0-6.037c-.973,0-1.346.435-1.346,1.26v1.962c0,.825.373,1.256,1.346,1.256s1.35-.435,1.35-1.256v-1.966C1566.927,244.695,1566.553,244.26,1565.577,244.26Z",
    transform: "translate(-1549.76 -242.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.349)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.488,188.243c0,.973.419,1.543,1.736,1.543a10.661,10.661,0,0,0,1.543-.119v-3.029h1.785v4.391a12.813,12.813,0,0,1-3.341.451c-2.442,0-3.612-1.034-3.612-3.012v-4.256c0-2.052,1.2-3.012,3.792-3.012a12.251,12.251,0,0,1,2.861.328l-.209,1.646a13.391,13.391,0,0,0-2.8-.271c-1.317,0-1.752.542-1.752,1.56Z",
    transform: "translate(-133.6 -181.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.18,194.877l-2.29-3.3h-1.8v3.3H352.2V184.9h4.092c2.323,0,3.177.944,3.177,2.7V188.9a2.277,2.277,0,0,1-1.5,2.413l2.471,3.562Zm-1.962-8.315h-2.13v3.386h2.13c1.034,0,1.363-.378,1.363-1.215v-.989C357.58,186.907,357.223,186.562,356.218,186.562Z",
    transform: "translate(-343.229 -184.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M580.108,192.809h-3.7l-.632,2.068H573.8l3.148-9.977h2.639l3.144,9.977h-1.978Zm-3.234-1.633h2.758l-1.363-4.72Z",
    transform: "translate(-555.734 -184.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M831.614,184.9c2.458,0,3.312,1.244,3.312,2.684v4.609c0,1.424-.854,2.684-3.312,2.684H827.9V184.9Zm-1.826,8.315h1.633c1.276,0,1.617-.509,1.617-1.469v-3.714c0-.96-.345-1.469-1.617-1.469h-1.633Z",
    transform: "translate(-799.406 -184.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1048.3,184.9h6.115v1.662h-4.227v2.413h3.895v1.662h-3.895v2.577h4.227v1.662H1048.3Z",
    transform: "translate(-1010.76 -184.748)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.096 4.839)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 2.856,
    transform: "translate(0 0.833)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.852,
    height: 1.665
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.456 6.263)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.893 0.275)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2168.182,185.8c2.433,0,3.282,1.231,3.282,2.655v4.572c0,1.412-.845,2.659-3.282,2.659H2164.5V185.8Zm-1.81,8.241h1.616c1.26,0,1.6-.5,1.6-1.457V188.9c0-.952-.341-1.453-1.6-1.453h-1.616Z",
    transform: "translate(-2164.5 -185.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2367.662,187.446H2364.9V185.8h7.392v1.646h-2.762v8.241h-1.872Z",
    transform: "translate(-2356.676 -185.8)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1954.842,183.947h-2.766v1.617h.96v2a10.9,10.9,0,0,1-1.564.119c-1.338,0-1.761-.571-1.761-1.543v-3.776c0-1.018.439-1.56,1.777-1.56a13.5,13.5,0,0,1,2.84.271l.213-1.646a12.587,12.587,0,0,0-2.9-.328c-2.627,0-3.842.956-3.842,3.008v4.26c0,1.978,1.182,3.012,3.661,3.012a13.15,13.15,0,0,0,3.386-.451Z",
    transform: "translate(-1947.8 -179.1)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.506,
    height: 21.801,
    transform: "translate(69.038)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M106.389,23.385H2.762A2.739,2.739,0,0,1,0,20.676V2.709A2.739,2.739,0,0,1,2.762,0H106.389a2.739,2.739,0,0,1,2.762,2.709V20.676A2.739,2.739,0,0,1,106.389,23.385ZM2.762,1.506a1.235,1.235,0,0,0-1.256,1.2V20.676a1.23,1.23,0,0,0,1.256,1.2H106.389a1.23,1.23,0,0,0,1.256-1.2V2.709a1.23,1.23,0,0,0-1.256-1.2Z",
    transform: "translate(0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradeproLogo);
export default __webpack_public_path__ + "static/media/gradepro-logo.f132960f38c87263f6b03a2160e94764.svg";
export { ForwardRef as ReactComponent };